import React from "react";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme: any) => ({
  button: { fontSize: "1.2em" },
  submitting: { marginLeft: theme.spacing(1) },
}));

export default function SubmitButton(props) {
  const classes = useStyles();
  const { isSubmitting, text } = props;

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <Button
        variant="contained"
        color="primary"
        type="submit"
        disabled={isSubmitting}
        className={classes.button}
      >
        {text}
        {isSubmitting && (
          <CircularProgress
            color="primary"
            size={25}
            className={classes.submitting}
          />
        )}
      </Button>
    </div>
  );
}
